import { Wallet, BarChart3, Sparkles, MonitorSmartphone } from "lucide-react";
import { Reveal } from "./Reveal";

const features = [
  {
    icon: Wallet,
    title: "Effortless tracking",
    text: "Record expenses and income in seconds — categories, notes and recurring entries handled for you.",
  },
  {
    icon: BarChart3,
    title: "Reports & statistics",
    text: "Monthly trends, category breakdowns and exportable summaries that actually make sense at a glance.",
  },
  {
    icon: Sparkles,
    title: "Optional AI assistance",
    text: "Turn it on when you want pattern-spotting and gentle nudges. Off means fully manual, fully private.",
  },
  {
    icon: MonitorSmartphone,
    title: "Mobile + desktop",
    text: "One continuous ledger across phone and PC. Offline first, synced the moment you're back online.",
  },
];

export const Features = () => (
  <section id="features" className="mx-auto max-w-7xl px-6 pb-28 lg:px-10 lg:pb-36" data-testid="features-section">
    <Reveal>
      <p className="font-mono-num text-xs uppercase tracking-[0.3em] text-sky-400">Features</p>
      <h2 className="font-serif-display mt-4 max-w-xl text-2xl tracking-tight text-slate-100 sm:text-3xl lg:text-4xl">
        Everything you need. Nothing that shouts.
      </h2>
    </Reveal>
    <div className="mt-14 grid gap-5 sm:grid-cols-2 lg:grid-cols-4" data-testid="features-grid">
      {features.map((f, i) => (
        <Reveal key={f.title} delay={0.08 * i} className="h-full">
          <div
            className="group h-full rounded-3xl border border-sky-400/10 bg-[#132342]/40 p-7 transition-all duration-500 hover:-translate-y-1.5 hover:border-sky-400/40 hover:bg-[#1B2F56]/50 hover:shadow-[0_24px_60px_-20px_rgba(56,189,248,0.35)]"
            data-testid={`feature-card-${i}`}
          >
            <div className="flex h-11 w-11 items-center justify-center rounded-2xl border border-sky-400/20 bg-sky-400/10 text-sky-300 transition-transform duration-500 group-hover:scale-110">
              <f.icon size={20} />
            </div>
            <h3 className="font-serif-display mt-6 text-xl text-slate-100">{f.title}</h3>
            <p className="mt-3 text-sm leading-relaxed text-slate-400">{f.text}</p>
          </div>
        </Reveal>
      ))}
    </div>
  </section>
);
